import Image from 'next/image';
import Link from 'next/link';
import PhoneInput from 'react-phone-number-input/input';
import { isValidPhoneNumber } from 'react-phone-number-input';
import { getCountries } from 'react-phone-number-input/input';
import { toast } from 'react-toastify';
import en from 'react-phone-number-input/locale/en.json';
import { ChangeEvent, SetStateAction, useEffect, useState } from 'react';
import { Formik, ErrorMessage, Field, Form } from 'formik';
import styled from 'styled-components';
import { useMutation } from '@apollo/client';
import {
  INSERT_AFFILIATES,
  INSERT_AFFILIATES_INTERFACE
} from '../../api/affiliates';

interface Locale {
  [key: string]: string;
}
interface IProps {
  openModal: boolean;
  setOpenModal: React.Dispatch<SetStateAction<boolean>>;
  openModal2: boolean;
  setOpenModal2: React.Dispatch<SetStateAction<boolean>>;
}
interface Props {
  isChecked: boolean;
}
// const CheckBoxTextStyle = styled.p<Props>`
//   opacity: ${props => (props.isChecked ? '1' : '0.5')};
// `;
interface StyleProps {
  valid: boolean;
}
const StylePhone = styled(PhoneInput)<StyleProps>`
  width: 100%;
  gap: 2.5rem;
  border: 1px solid lightgray;
  padding: 0.5rem;
  border-radius: 4px;
  outline-color: ${props => (props.valid ? 'none' : 'red')};
`;
const StyleField = styled.div`
  position: relative;
  input:valid + .placeholder,
  input:-webkit-autofill + .placeholder {
    display: none;
  }
  .placeholder {
    position: absolute;
    pointer-events: none;
    top: 10px;
    bottom: 0;
    left: 10px;
  }
`;
const StyleSelect = styled.div`
  select:-webkit-autofill + .select-placeholder {
    display: none;
  }

  /* Show the placeholder by default */
  .select-placeholder {
    /* Additional styling for the placeholder */
    position: absolute;
    pointer-events: none;
    top: 8px;
    left: 10px;
    color: #999; /* Placeholder text color */
  }
`;
const StyleModal = styled.div`
  animation: drop 0.5s ease forwards;
  @keyframes drop {
    0% {
      transform: translateY(0px);
    }
    70% {
      transform: translateY(30px);
    }
    100% {
      transform: translateY(0px);
    }
  }
`;
const PartnerModal = ({
  openModal,
  setOpenModal,
  setOpenModal2,
  openModal2
}: IProps) => {
  const [selectedCountry, setSelectedCountry] = useState<any>();
  const [phone, setPhone] = useState<string | undefined>();
  const [validPhone, setValidPhone] = useState<boolean>(false);
  const [info, setInfo] = useState<Record<string, any>>({
    fName: '',
    lName: '',
    country: '',
    phone: '',
    email: '',
    bName: '',
    link: '',
    interest: ''
  });
  const [errorStates, setErrorStates] = useState<Record<string, boolean>>({
    fields: false,
    check: false,
    validEmail: false
  });
  const [terms, setTerms] = useState<boolean>(false);

  const [addAffiliates, { data, loading }] = useMutation(INSERT_AFFILIATES);
  useEffect(() => {
    if (document) {
      document.body.style.overflow = openModal ? 'hidden' : 'unset';

      return () => {
        document.body.style.overflow = 'unset'; // Restore scrolling when component unmounts
      };
    }
  }, [openModal]);
  useEffect(() => {
    if (terms) {
      setErrorStates({
        ...errorStates,
        check: false
      });
    }
  }, [terms]);
  useEffect(() => {
    setInfo({
      ...info,
      phone: phone
    });
    if (phone && phone.length > 1) {
      setValidPhone(isValidPhoneNumber(phone));
    }
  }, [phone]);

  const handleCheck = (e: ChangeEvent<HTMLInputElement>) => {
    setTerms(!terms);
  };
  const handleChange = (
    newValue: any,
    setFieldValue: (field: string, value: any, shouldValidate?: boolean) => void
  ) => {
    setPhone(newValue);
    setFieldValue('phone', newValue);
  };
  return (
    <>
      <div
        id="partner-modal-wrapper"
        className={`${
          openModal ? 'flex' : 'hidden'
        } fixed top-0 left-0 w-screen h-screen bg-[#0c0d0dc0] justify-center items-center z-[2000]`}
        onClick={() => {
          setOpenModal(!openModal);
        }}
      >
        <StyleModal
          id="modal"
          onClick={(e: any) => {
            e.stopPropagation();
          }}
          className="relative bg-white w-[80%] md:w-[65%] xl:w-[70%] max-w-[80%] min-w-[60%] max-h-[83vh] sm:max-h-[85vh] overflow-auto flex justify-center xl:justify-start z-50 mb-14 "
        >
          <Image
            src="https://res.cloudinary.com/see-sight-tours/image/upload/v1690446353/icons-website/radix-icons_cross-circled_imsehm.svg"
            width={40}
            height={40}
            alt="cross-button"
            className="hidden xl:block absolute top-2 left-2 z-10 hover:cursor-pointer"
            onClick={() => {
              setOpenModal(false);
            }}
          />
          <Image
            src="https://res.cloudinary.com/see-sight-tours/image/upload/v1690446499/icons-website/radix-icons_cross-circled_1_kwu0u0.svg"
            width={20}
            height={20}
            alt="cross-button"
            className="block xl:hidden absolute top-2 left-2 z-10 hover:cursor-pointer"
            onClick={() => {
              setOpenModal(false);
            }}
          />
          <div className="min-w-[45%] w-[45%] h-[100] relative hidden xl:block">
            <Image
              src={
                'https://res.cloudinary.com/see-sight-tours/image/upload/q_auto,f_auto,c_fill,g_faces,h_570,w_1920,y_0/v1582036498/Happy-group-tour-guides.jpg'
              }
              quality={100}
              fill
              className="object-cover opacity-80"
              alt="https://res.cloudinary.com/see-sight-tours/image/upload/v1689924448/Remaining%20images/Partners/Social_SignUp_eelrug.jpg"
            />
          </div>
          <div className=" pt-[8%] pb-[3%] xl:pt-[6%] min-w-[50%] px-6 relative w-full">
            <h2 className="text-sm md:text-lg lg:text-[24px] 2xl:text-[28px] font-bold text-[#333333]">
              Affiliate Partner Application
            </h2>
            <p className="text-xs md:text-base 2xl:text-lg font-normal mt-1 text-[#4f4f4fb2]">
              Review our Terms of Service for more details
            </p>
            <Formik
              initialValues={info}
              validate={values => {
                if (values.email.length > 0) {
                  setErrorStates({
                    ...errorStates,
                    validEmail: true
                  });
                } else {
                  setErrorStates({
                    ...errorStates,
                    validEmail: false
                  });
                }
                setSelectedCountry(values.country);
                const errors: any = {};
                if (
                  !/^[a-zA-Z-\s]{0,30}$/.test(values.fName) ||
                  values.fName === ''
                ) {
                  errors.fName = 'Enter valid first name';
                } else if (
                  !/^[a-zA-Z-\s]{0,30}$/.test(values.lName) ||
                  values.lName === ''
                ) {
                  errors.lName = 'Enter valid last name';
                } else if (values.country === '') {
                  errors.country = 'Please select country';
                } else if (values.phone === '' || !validPhone) {
                  errors.phone = 'Invalid phone number';
                } else if (
                  values.email === '' ||
                  values.email.length < 1 ||
                  !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(values.email)
                ) {
                  errors.email = 'Valid email is must';
                } else if (
                  values.link === '' ||
                  (!values.link.includes('http') &&
                    !values.link.includes('ftp')) ||
                  values.link.length < 0
                ) {
                  errors.link = 'Enter valid website/social link';
                } else if (
                  values.interest === '' ||
                  values.interest.length < 10
                ) {
                  errors.interest =
                    'Reason should be 10 characters long atleast';
                }
                return errors;
              }}
              onSubmit={async (
                values: Record<string, any>,
                { setSubmitting }
              ) => {
                if (!terms) {
                  setErrorStates({
                    ...errorStates,
                    check: true
                  });
                  return;
                }
                const filterValues = Object.keys(values).reduce(
                  (acc: any, key: any) => {
                    if (values[key] !== '') {
                      acc[key] = values[key];
                    }
                    return acc;
                  },
                  {}
                );
                setErrorStates({
                  ...errorStates,
                  check: false
                });
                const email = {
                  firstName: filterValues.fName,
                  lastName: filterValues.lName,
                  country: (en as Locale)[filterValues.country],
                  phone: filterValues.phone,
                  email: filterValues.email,
                  bussinessName: filterValues.bName
                    ? filterValues.bName
                    : 'NIL',
                  link: filterValues.link,
                  reason: filterValues.interest
                };
                await addAffiliates({
                  variables: {
                    object: {
                      first_name: filterValues.fName,
                      last_name: filterValues.lName,
                      country: filterValues.country,
                      phone: filterValues.phone,
                      email: filterValues.email,
                      bussiness_name: filterValues.bName || filterValues.bName,
                      social_link: filterValues.link,
                      reason: filterValues.interest,
                      status: 'PENDING'
                    }
                  }
                });

                await fetch('/api/mail', {
                  method: 'POST',
                  body: JSON.stringify(email)
                });

                setOpenModal(false);
                setOpenModal2(true);

                // toast.success(
                //   <div>
                //     <h3 className="text-black text-base font-semibold">
                //       Thank You
                //     </h3>
                //     <p>
                //       We Received Your Application, We Will Inform You Shortly
                //     </p>
                //   </div>
                // );
              }}
            >
              {({ isSubmitting, values, setFieldValue }) => (
                <Form className="relative" autoComplete="off">
                  <div className="md:flex justify-between gap-2 w-full">
                    <div className="flex-none w-full md:w-[46%]">
                      <StyleField className="mt-3 md:mt-0">
                        <Field
                          id="fName"
                          name="fName"
                          type="text"
                          required
                          autocomplete="off"
                          aria-autocomplete="none"
                          className="focus:outline-none border border-slate-200 p-2 rounded-[4px] w-full text-xs lg:text-base"
                        />
                        <div className="placeholder text-slate-400 text-xs lg:text-base">
                          First Name <span className="text-blue-500">*</span>
                        </div>
                      </StyleField>

                      <ErrorMessage
                        name="fName"
                        component="div"
                        className="text-red-400 text-[10px] sm:text-xs md:text-sm"
                      />
                    </div>
                    <div className="flex-none w-full md:w-[46%]">
                      <StyleField className="mt-3 md:mt-0">
                        <Field
                          id="lName"
                          name="lName"
                          type="text"
                          required
                          autoComplete="off"
                          className="focus:outline-none border border-slate-200 p-2 rounded-[4px] w-full text-xs lg:text-base"
                        />
                        <div className="placeholder text-slate-400 text-xs lg:text-base">
                          Last Name <span className="text-blue-500">*</span>
                        </div>
                      </StyleField>
                      <ErrorMessage
                        name="lName"
                        component="div"
                        className="text-red-400 text-[10px] sm:text-xs md:text-sm"
                      />
                    </div>
                  </div>
                  <div className="md:flex justify-between gap-2 w-full mt-3 md:mt-5">
                    <div className="flex-nonew w-full md:w-[46%]">
                      <div className="relative">
                        <StyleSelect>
                          <Field
                            id="country"
                            name="country"
                            as="select"
                            autoComplete="off"
                            className={`w-full border border-slate-200 rounded-md hover:cursor-pointer text-xs lg:text-base ${
                              !selectedCountry
                                ? 'text-slate-400'
                                : 'text-[#333333]'
                            }`}
                            style={{
                              height: '2.4rem',
                              backgroundColor: 'white'
                            }}
                          >
                            <option
                              value=""
                              disabled
                              selected
                              className="hidden"
                            ></option>
                            {getCountries().map(
                              (country: any, index: number) => (
                                <option
                                  key={index}
                                  value={country}
                                  className="hover:cursor-pointer w-full text-black"
                                  onClick={() =>
                                    setSelectedCountry((en as Locale)[country])
                                  }
                                >
                                  {(en as Locale)[country]}
                                </option>
                              )
                            )}
                          </Field>
                          <div
                            className={`select-placeholder focus:hidden ${
                              selectedCountry ? 'hidden' : 'block'
                            } absolute top-[10px] text-xs lg:text-base left-[10px] text-red text-slate-400`}
                          >
                            Country <span className="text-blue-400">*</span>
                          </div>
                        </StyleSelect>
                      </div>

                      <ErrorMessage
                        name="country"
                        component="div"
                        className="text-red-400 text-[10px] sm:text-xs md:text-sm"
                      />
                    </div>
                    <div className="flex-none w-full mt-3 md:mt-0 md:w-[46%]">
                      <StylePhone
                        value={phone}
                        international
                        withCountryCallingCode
                        onChange={(newValue: any) =>
                          handleChange(newValue, setFieldValue)
                        }
                        valid={validPhone}
                        //@ts-ignore
                        country={selectedCountry}
                        placeholder="Phone"
                        className="text-xs lg:text-base"
                      />
                      <ErrorMessage
                        name="phone"
                        component="div"
                        className="text-red-400 text-[10px] sm:text-xs md:text-sm"
                      />
                    </div>
                  </div>
                  <StyleField className="my-3 lg:my-5">
                    <Field
                      id="email"
                      name="email"
                      type="email"
                      required
                      className="focus:outline-none border border-slate-200 p-2 rounded-[4px] w-full text-xs lg:text-base"
                    />
                    {!errorStates.validEmail && (
                      <div className="placeholder text-slate-400 text-xs lg:text-base">
                        Email <span className="text-blue-500">*</span>
                      </div>
                    )}
                  </StyleField>
                  <ErrorMessage
                    name="email"
                    component="div"
                    className="text-red-400 text-[10px] sm:text-xs md:text-sm "
                  />
                  <StyleField className="my-3 lg:my-5">
                    <Field
                      id="bName"
                      name="bName"
                      type="text"
                      placeholder="Business Name (optional)"
                      className="focus:outline-none border border-slate-200 p-2 rounded-[4px] w-full text-xs lg:text-base"
                    />
                    <div className="placeholder text-slate-400 text-xs lg:text-base">
                      Business Name
                      <span className="text-slate-400 text-xs">
                        {'(optional)'}
                      </span>
                    </div>
                  </StyleField>
                  <ErrorMessage
                    name="bName"
                    component="div"
                    className="text-red-400 text-[10px] sm:text-xs md:text-sm"
                  />
                  <StyleField className="mb-2">
                    <Field
                      id="link"
                      name="link"
                      type="text"
                      required
                      className="focus:outline-none border border-slate-200 p-2 rounded-[4px] w-full text-xs lg:text-base"
                    />
                    <div className="placeholder text-slate-400 text-xs lg:text-base">
                      Website / LinkedIn{' '}
                      <span className="text-blue-500">*</span>
                    </div>
                  </StyleField>
                  <ErrorMessage
                    name="link"
                    component="div"
                    className="text-red-400 text-[10px] sm:text-xs md:text-sm "
                  />
                  <label className="mt-3 text-[#828282] text-xs lg:text-base">
                    Why are you interested in becoming a See Sight Tours
                    affiliate partner? *
                  </label>
                  <Field
                    id="interest"
                    name="interest"
                    as="textarea"
                    required
                    placeholder="Short description..."
                    className="w-full text-start placeholder:text-start mt-1 md:mt-2 focus:outline-none border border-slate-200 p-2 rounded-[4px] block lg:h-[120px] overflow-auto text-xs lg:text-base"
                  />
                  <ErrorMessage
                    name="interest"
                    component="div"
                    className="text-red-400 text-[10px] sm:text-xs md:text-sm"
                  />
                  <div className="flex items-center gap-3 pt-3">
                    <input
                      type="checkbox"
                      name="termsConditions"
                      checked={terms}
                      onChange={handleCheck}
                    />

                    <p className="text-[10px] lg:text-xs text-justify  font-[500] text-xs hover:cursor-pointer text-[#333333] ">
                      This means you’re okay with our Terms of Service,{' '}
                      <span className="text-sky-500 underline">
                        <Link href={'/privacy'} target="_blank">
                          Privacy Policy
                        </Link>
                      </span>{' '}
                      of See Sight Tours
                    </p>
                  </div>
                  {errorStates.check && (
                    <p className="text-[10px] sm:text-xs md:text-sm text-blue-500 block">
                      Please agree our terms
                    </p>
                  )}
                  <div className="pt-5 pb-10">
                    {' '}
                    <button
                      className="p-2 mb-10 focus:outline-none flex justify-center items-center  bg-primary hover:bg-[#2E3D7A] active:bg-[#2E3D7A] text-white float-right rounded-[10px] text-sm lg:text-base font-normal"
                      type="submit"
                      disabled={isSubmitting}
                    >
                      {loading ? (
                        <>
                          <svg
                            aria-hidden="true"
                            role="status"
                            className="inline w-4 h-4 mr-3 text-gray-200 animate-spin dark:text-gray-600"
                            viewBox="0 0 100 101"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                              fill="currentColor"
                            />
                            <path
                              d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                              fill="#1C64F2"
                            />
                          </svg>
                          Loading...
                        </>
                      ) : (
                        'Submit Application'
                      )}
                    </button>
                  </div>{' '}
                  <Image
                    src={
                      'https://res.cloudinary.com/see-sight-tours/image/upload/v1689937350/Remaining%20images/Partners/Group_21_e8zxxn.svg'
                    }
                    width={50}
                    height={50}
                    className="hidden sm:block absolute -bottom-16 -left-4"
                    alt="https://res.cloudinary.com/see-sight-tours/image/upload/v1689937350/Remaining%20images/Partners/Group_21_e8zxxn.svg"
                  />
                  <Image
                    src={
                      'https://res.cloudinary.com/see-sight-tours/image/upload/v1689937350/Remaining%20images/Partners/Group_21_e8zxxn.svg'
                    }
                    width={35}
                    height={35}
                    className="block sm:hidden absolute -bottom-8 -left-3"
                    alt="https://res.cloudinary.com/see-sight-tours/image/upload/v1689937350/Remaining%20images/Partners/Group_21_e8zxxn.svg"
                  />
                </Form>
              )}
            </Formik>{' '}
          </div>
          <Image
            src={
              'https://res.cloudinary.com/see-sight-tours/image/upload/v1689937350/Remaining%20images/Partners/Group_21_e8zxxn.svg'
            }
            width={50}
            height={50}
            className="absolute top-2 right-2 hidden sm:block"
            alt="https://res.cloudinary.com/see-sight-tours/image/upload/v1689937350/Remaining%20images/Partners/Group_21_e8zxxn.svg"
          />
          <Image
            src={
              'https://res.cloudinary.com/see-sight-tours/image/upload/v1689937350/Remaining%20images/Partners/Group_21_e8zxxn.svg'
            }
            width={35}
            height={35}
            className="absolute top-2 right-2 block sm:hidden"
            alt="https://res.cloudinary.com/see-sight-tours/image/upload/v1689937350/Remaining%20images/Partners/Group_21_e8zxxn.svg"
          />
        </StyleModal>
      </div>
    </>
  );
};

export default PartnerModal;
